__turbopack_context__.v({
  "container": "boat_overview-module-scss-module__r6SdjG__container",
  "containerContent": "boat_overview-module-scss-module__r6SdjG__containerContent",
  "containerImage": "boat_overview-module-scss-module__r6SdjG__containerImage",
  "contentMenu": "boat_overview-module-scss-module__r6SdjG__contentMenu",
  "contentTitle": "boat_overview-module-scss-module__r6SdjG__contentTitle",
  "image": "boat_overview-module-scss-module__r6SdjG__image",
  "itemDesc": "boat_overview-module-scss-module__r6SdjG__itemDesc",
  "itemLinkStyles": "boat_overview-module-scss-module__r6SdjG__itemLinkStyles",
  "itemTitle": "boat_overview-module-scss-module__r6SdjG__itemTitle",
  "menuItem": "boat_overview-module-scss-module__r6SdjG__menuItem",
});
